<template>
    <div>
        <img src="../../../public/img/icons/apple-icon-57x57.png" height="32" width="32"/>
    </div>
</template>

<script>
    export default {
        name: "RichLogo"
    }
</script>

<style scoped lang="scss">
    div{
        padding: 12px 12px 12px 0;
    }
</style>
